import base64url from 'base64url'

const encryptForm = (formElement) => {
  return window.adyen.createEncryptedForm(formElement, {}).encrypt()
}

// const getProviderData = (email, locale, resultUrl) => {
//   return '{' +
//     '"shopperEmail": "' + email + '", ' +
//     '"resultURL":"' + (resultUrl || '') + '", ' +
//     '"use3DSecure20": true, ' +
//     '"3dSecure2.deviceChannel": "browser", ' +
//     '"browserInfo.language": "' + locale + '", ' +
//     '"browserInfo.colorDepth": ' + screen.colorDepth + ', ' +
//     '"browserInfo.screenHeight": ' + window.innerHeight + ', ' +
//     '"browserInfo.screenWidth": ' + window.innerWidth + ', ' +
//     '"browserInfo.timeZoneOffset": ' + new Date().getTimezoneOffset() + ', ' +
//     '"browserInfo.javaEnabled": ' + ((window.navigator && window.navigator.javaEnabled && window.navigator.javaEnabled()) || false) + ' ' +
//   '}'
// }

const getProviderData = (email, locale, resultUrl, payload) => {
  return {
    requestHeaderAccept: 'application/json, text/javascript',
    requestHeaderUserAgent: window.navigator.userAgent,
    paymentDetails: payload,
    shopperEmail: email,
    resultURL: (resultUrl || ''),
    use3DSecure20: true,
    origin: window.location.origin,
    '3dSecure2.deviceChannel': 'browser',
    'browserInfo.language': locale,
    'browserInfo.colorDepth': screen.colorDepth,
    'browserInfo.screenHeight': window.innerHeight,
    'browserInfo.screenWidth': window.innerWidth,
    'browserInfo.timeZoneOffset': new Date().getTimezoneOffset(),
    'browserInfo.javaEnabled': ((window.navigator && window.navigator.javaEnabled && window.navigator.javaEnabled()) || false)
  }
}

const hasToExecute3DSecure = (providerData) => {
  if (!providerData) {
    return false
  }

  try {
    var providerDataConverted = {}

    if (typeof providerData === 'string') {
      providerDataConverted = JSON.parse(providerData)
    } else {
      providerDataConverted = providerData
    }

    return !!(providerDataConverted.postUrl || providerDataConverted.redirectType)
  } catch (ex) {
    var error = new Error('Error Getting Provider Data')
    error.stack += '\nInner Error: ' + ex.stack

    return false
  }
}

const execute3DSecure = (providerData) => {
  // V46 - https://docs.adyen.com/online-payments/classic-integrations/api-integration-ecommerce/3d-secure/native-3ds2/browser-based-integration
  // const providerData = typeof paymentModel.providerData === 'string'
  //   ? JSON.parse(paymentModel.providerData)
  //   : paymentModel.providerData
  let username = providerData.name // Should not work.

  let inputFields = []

  const form = document.createElement('form')
  form.setAttribute('method', 'POST')

  /*
  providerData = {
    redirectType: "IdentifyShopper" | "ChallangeShopper" | "RedirectShopper"
  }
  */
  if (providerData.redirectType && providerData.redirectType.trim() === 'IdentifyShopper') {
    form.setAttribute('action', providerData.threeDSMethodURL)

    let data = {
      threeDSServerTransID: providerData.threeDSServerTransID,
      threeDSMethodNotificationURL: providerData.threeDSMethodNotificationURL
    }

    var base64 = base64url.encode(JSON.stringify(data)) // btoa(JSON.stringify(data))

    inputFields = [{
      name: 'threeDSMethodData',
      value: base64
    }]
  } else if (providerData.redirectType && providerData.redirectType.trim() === 'ChallengeShopper') {
    form.setAttribute('action', providerData.acsURL)

    var cReqData = {
      threeDSServerTransID: providerData.threeDSServerTransID,
      acsTransID: providerData.acsTransID,
      messageVersion: providerData.messageVersion,
      challengeWindowSize: '05',
      messageType: 'CReq'
    }

    var challengeShopperEncoded = base64url.encode(JSON.stringify(cReqData)) // btoa(JSON.stringify(cReqData))
    inputFields = [{
      name: 'creq',
      value: challengeShopperEncoded
    }]
  } else {
    form.setAttribute('action', providerData.postUrl)
    // 3DS1: RedirectShopper
    if (username === undefined || username === null) {
      username = ' '
    }

    var splitName = username.split(' ')
    inputFields = Object.keys(providerData).map((key) => {
      return {
        name: key,
        value: providerData[key]
      }
    })

    inputFields.push({ name: 'shopper.firstName', value: splitName[0] })
    inputFields.push({ name: 'shopper.lastName', value: splitName[1] })
  }

  inputFields.forEach(field => {
    let input = document.createElement('input')
    input.setAttribute('name', field.name)
    input.setAttribute('value', field.value)
    form.appendChild(input)
  })
  document.body.appendChild(form)

  form.submit()
}

export {
  encryptForm,
  getProviderData,
  hasToExecute3DSecure,
  execute3DSecure
}



// WEBPACK FOOTER //
// ./src/utils/adyen.js